import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClaimStoreState } from "../types/claim";
import { SearchDefaultValue, SearchValue } from "./types";

const initialState: ClaimStoreState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const claim = createSlice({
  name: "claim",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = claim.actions;

export const selectSearchValue = (state: { claim: ClaimStoreState }) =>
  state?.claim?.searchValue;
export const selectIsActive = (state: { claim: ClaimStoreState }) =>
  state?.claim?.isActive;

export default claim.reducer;
